import { useEffect, useState, useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { Box, Button } from '@mui/material'
import AuthError from '../../components/auth/authError'
import AuthHeader from '../../components/auth/authHeader'
import { AuthContext } from '../../contexts/auth/authContext'
import custom from '../../styles/mui/szVariables.json'
import { useValidPassword } from '../../hooks/auth/useAuthHooks'
import { Password } from '../../components/auth/authComponents'
import { analyticsPage, analyticsDomain, analyticsCta } from '../../services/constants'
import { sendClickAnalytics, sendViewAnalytics } from '../../components/common/util/util'

export default function ChangePassword() {
  const navigate = useNavigate()
  const auth = useContext(AuthContext)   
  const { password, setPassword, passwordIsValid } = useValidPassword('')
  const [error, setError] = useState('')
  const [valid, setValid] = useState(false)
  const {
    password: passwordConfirm,
    setPassword: setPasswordConfirm,
    passwordIsValid: passwordConfirmIsValid,
  } = useValidPassword('')

  const isNotValid =
    !valid ||
    password.length === 0 ||
    passwordConfirm.length === 0 


  const changePasswordClicked = async () => {
    try {
      if(password !== passwordConfirm) {
        setError('Password mismatch')
      } else {
        setError('') 
        if(auth?.authCode) {  
          await auth.changeUserPassword(password)
          await auth.signInWithEmail(auth?.userEmail, password)
          sendClickAnalytics('/passwordchange', {
              domain: analyticsDomain.welcome,
              name: analyticsCta.changePassword,
              metadata: {},
            })
          navigate('/')
        } else {
          setError('Auth code missing, please click resend code')
        }
      }
    } catch (err: any) {
      sendClickAnalytics('/passwordchange', {
          domain: analyticsDomain.welcome,
          name: analyticsCta.changePasswordError,
          metadata: { message: err.message },
        })
      setError(err.message)
    }
  }

  function handleEnterKey(ev: any) {
    if(ev.key === "Enter" && 
        !isNotValid )  {
      changePasswordClicked()
    }
  }

  useEffect(()=>{
    if(!auth?.authCode) {
      navigate('/requestcode')
    }
    sendViewAnalytics('/passwordchange', {
        domain: analyticsDomain.welcome,
        name: analyticsPage.changePassword
      })
  },[])

  return (
    <AuthHeader 
          id="changepassword" 
          title="Setup new password"
          description="Create a new password for your SolarZero account."
          >

        <AuthError error={error} />

        <Box width="100%" mt={custom.spacing.md}>
          <Password label="New Password" 
            passwordIsValid={passwordIsValid} 
            setPassword={setPassword} 
            validation={setValid} 
            onKeyUp={handleEnterKey}
            />
        </Box>
        <Box width="100%" mt={custom.spacing.sm}>
          <Password label="Confirm Password" 
            confirmPass={password !== passwordConfirm && passwordConfirm.length>0}
            passwordIsValid={passwordConfirmIsValid} 
            setPassword={setPasswordConfirm}
            onKeyUp={handleEnterKey}
            />
        </Box>
        <Box width="100%" mt={custom.spacing.sm}>
          <Button id="changePassword"  
            disabled={isNotValid} 
            color="primary" 
            fullWidth
            variant="contained" 
            onKeyUp={handleEnterKey}
            onClick={changePasswordClicked}>
            Change password
          </Button>
        </Box>
    </AuthHeader>
  )
}

